import type { FailureCode } from '@rp/contracts'

export const API_COPY = {
  malformed: '伺服器回應的格式無法辨識，請重新整理',
  offline: '連線不到伺服器，請檢查網絡後再試',
  unknownFailure: (code: string) => `未知的錯誤（${code}）`,
} as const

export const FAILURE_CODE_COPY: Record<FailureCode, string> = {
  database_query_failed: '資料庫發生錯誤，請稍後再試',
  input_invalid: '資料格式不正確',
  request_failed: '請求失敗，請稍後再試',
  unexpected_failure: '發生預期之外的錯誤，請稍後再試',
  provider_unavailable: 'AI 服務暫時無法連線，請稍後再試',
  provider_rejected: 'AI 服務拒絕處理這個內容',
  provider_timeout: 'AI 服務回應逾時，請稍後再試',
  provider_rate_limited: 'AI 服務用量已達上限，請稍後再試',
  meta_unavailable: 'Meta 服務暫時無法連線，請稍後再試',
  meta_rejected: 'Meta 拒絕了這個請求',
  meta_timeout: 'Meta 回應逾時，請稍後再試',
  meta_auth: 'Meta 授權已失效，請重新連接粉專',
  meta_not_found: 'Meta 找不到這個項目',
  meta_object_unavailable: 'Meta 無法提供這個項目的內容',
  job_payload_invalid: '這個工作的內容格式不正確，重送也不會成功，請聯絡我們',
  tenant_inactive: '這個公司帳戶已停用',
  conversation_not_in_tenant: '這則對話不屬於這間公司',
  conversation_missing: '找不到這則對話',
  message_not_in_conversation: '這則訊息不屬於該對話',
  message_not_recorded: '系統沒有這則訊息的紀錄',
  channel_not_in_tenant: '這個粉專不屬於這間公司',
  channel_token_missing: '這個粉專未有授權，請重新連接',
  channel_token_unreadable: '這個粉專的授權無法讀取，請重新連接',
  kb_source_not_in_tenant: '這個知識來源不屬於這間公司',
  kb_source_url_blocked: '這個網址不允許匯入，請改用可公開瀏覽的網址',
  kb_source_unreadable: '無法讀取這份文件的內容，請確認檔案格式',
  kb_source_parse_incomplete: '解析這份文件未能完成，檔案本身沒有問題，請稍後再試',
  kb_source_fetch_failed: '取不到這個網址的內容，請確認網址後再試',
  kb_source_upload_unusable: '上傳的檔案無法使用，請重新上傳',
  suggestion_generation_failed: '未能生成建議草稿，請稍後再試',
  budget_exhausted: '本月 AI 用量已達上限，請聯絡管理員調高預算',
  credentials_missing: '尚未設定 AI 供應商金鑰，請聯絡管理員到「設定 → AI 供應商」填入',
}

const isFailureCode = (value: string): value is FailureCode => value in FAILURE_CODE_COPY

export const failureText = (value: string): string =>
  isFailureCode(value) ? FAILURE_CODE_COPY[value] : API_COPY.unknownFailure(value)
